<script>
  export default {
    props: {member:Object}
  }
</script>
<template>
  <div class="table-responsive mb-0">
    <table class="table">
      <tbody>
      <tr>
        <th scope="row">Full Name :</th>
        <td>{{member.fullname}}</td>
      </tr>
      <tr>
        <th scope="row">Gender :</th>
        <td>{{member.gender}}</td>
      </tr>
      <tr>
        <th scope="row">Date of birth :</th>
        <td>
          {{member.dob}}
          <br>
          <span class="text-muted small" v-show="member.age > 0">({{member.age}} Years)</span>
        </td>
      </tr>
      <tr>
        <th scope="row">Marital Status :</th>
        <td>{{member.marital_status}}</td>
      </tr>
      <tr>
        <th scope="row">Occupation :</th>
        <td>{{member.occupation}}</td>
      </tr>
      <tr>
        <th scope="row">Industries :</th>
        <td>
          <span class="badge badge-primary mr-2" v-for="industry in member.industries" :key="industry.id">
            {{industry.name}}
          </span>
        </td>
      </tr>
      <tr v-if="$store.getters.isLoggedIn">
        <th scope="row">Tags :</th>
        <td>
          <span class="badge badge-primary mr-2" v-for="tag in member.tags" :key="tag.id">
            {{tag.name}}
          </span>
        </td>
      </tr>
      <tr>
        <th scope="row">Mobile :</th>
        <td>
          <span v-if="member.mobile_number != null" v-b-tooltip.hover title="Click me to Call">
            <a :href="'tel:'+member.mobile_number.replace(/-|\+|\s/g,'')">
              <i class="bx bx-phone text-primary"></i>
            </a>
            </span>
          {{member.mobile_number}}
        </td>
      </tr>
      <tr>
        <th scope="row">Whatsapp Number :</th>
        <td>
          <span v-if="member.whatsapp_number != null" v-b-tooltip.hover title="Click me to Send Whatsapp Message">
            <a :href="'https://wa.me/'+member.whatsapp_number.replace(/-|\+|\s/g,'')">
              <i class="bx bxl-whatsapp text-success"></i>
            </a>
            {{member.whatsapp_number}}
          </span>
        </td>
      </tr>
      <tr>
        <th scope="row">E-mail :</th>
        <td>
          <span v-if="member.email != null" v-b-tooltip.hover title="Click me to Send Email">
            <a :href="'mailto:'+member.email">
              <i class="bx bx-envelope"></i>
            </a>
          </span>
          {{member.email}}
        </td>
      </tr>
      <tr>
        <th scope="row">Member? :</th>
        <td>{{ member.is_member ? 'Yes' : 'No'}}</td>
      </tr>
      <tr v-for="column in member.columns" :key="column.id">
        <th scope="row">
          {{column.key}}:
        </th>
        <td>{{column.value}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
